import { css } from "@emotion/css";
import {
  ColorSlider as AriaColorSlider,
  ColorSliderProps,
  ColorThumb,
  SliderTrack,
} from "react-aria-components";

export function ColorSlider(props: ColorSliderProps) {
  return (
    <AriaColorSlider {...props} className={styles.slider}>
      <SliderTrack className={styles.track}>
        <ColorThumb className={styles.thumb} />
      </SliderTrack>
    </AriaColorSlider>
  );
}

const styles = {
  track: css({
    gridArea: "track",
    borderRadius: 4,
    "[data-orientation='horizontal'] &": {
      height: 28,
    },
  }),
  thumb: css({
    border: "2px solid white",
    boxShadow: "0 0 0 1px black, inset 0 0 0 1px black",
    width: 20,
    height: 20,
    borderRadius: "50%",
    boxSizing: "border-box",
    "[data-orientation='horizontal'] &": {
      top: "50%",
    },
    "&[data-focus-visible]": {
      width: 24,
      height: 24,
    },
  }),
  slider: css({
    display: "grid",
    gridTemplateAreas: "'label output' 'track track'",
    gridTemplateColumns: "1fr auto",
    gap: 4,
    width: "100%",
    maxWidth: 300,
  }),
};
